import kr from '../kr/kr';

export default class CustomSelects extends kr.Component {
    async init() {
        this.SlimSelect = await import('slim-select');
        this.SlimSelect = this.SlimSelect.default;
        this.createCustomSelects();
    }
    createCustomSelects() {
        new this.SlimSelect({
            select: this.$element.querySelector('select')
        })
    }
}

kr.registerComponent('.js_select', {
    component: CustomSelects
});